import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import AllBetaEmails from './iOSBetaEmails';

class IOSBetaEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumbItems : [
                { title : "Minimis", link : "/" },
                { title : "iOS Beta Emails", link : "#" },
            ],
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="" breadcrumbItems={this.state.breadcrumbItems} />
                        <Row>
                               <AllBetaEmails/>
                        </Row>

                    </Container> 
                </div>
            </React.Fragment>
        );
    }
}

export default IOSBetaEmail;
